<fieldset ngModelGroup="studyInfoDetails">
  <h5 *ngIf="!(studyVM.study.studyId > 0)">Study Information</h5>
  <div id="dvStudyForm">
    <div class="row">
      <div class="col-12">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(clientName) || null }">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="clientName"
              name="clientName"
              [(ngModel)]="studyVM.study.clientName"
              #clientName="ngModel"
              pattern="{{ regularExpressionPattern.BasicPattern }}"
              maxlength="100"
              required
              appLabelFloat
            />
            <label for="clientName">Client Name</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(clientName) && clientName.errors.required"> Please enter a client name </span>
          <span class="help-block" *ngIf="showValidationMessage(clientName) && clientName.errors.pattern">
            Special characters are not allowed. (for example: !@#$%^&* etc)
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(studyName) || null }">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="studyName"
              name="studyName"
              [(ngModel)]="studyVM.study.studyName"
              #studyName="ngModel"
              pattern="{{ regularExpressionPattern.BasicPattern }}"
              maxlength="255"
              required
              appLabelFloat
            />
            <label for="studyName">Study Name</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(studyName) && studyName.errors.required"> Please enter a study name </span>
          <span class="help-block" *ngIf="showValidationMessage(studyName) && studyName.errors.pattern">
            special characters are not allowed. (for example: !@#$%^&* etc)
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="studySummary"
              name="studySummary"
              [(ngModel)]="studyVM.study.studySummary"
              #studySummary="ngModel"
              pattern="{{ regularExpressionPattern.AdvancedPattern }}"
              maxlength="300"
              appLabelFloat
            />
            <label for="studySummary">Study Summary</label>
          </span>
          <span class="help-block" *ngIf="studySummary.errors?.pattern"> special characters are not allowed. (for example: !@#$%^&* etc) </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(projectOfficeCountryId) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="projectOfficeCountryId"
              name="projectOfficeCountryId"
              [(ngModel)]="studyVM.study.projectOfficeCountryId"
              required
              #projectOfficeCountryId="ngModel"
              (ngModelChange)="projectOfficeCountryChange()"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.projectOfficeCountryId" [value]="undefined" disabled selected></option>
              <option *ngFor="let country of studyVM.countriesProjectOffice" [ngValue]="country.countryId">
                {{ country.countryName }}
              </option>
            </select>
            <label for="offcCountry">Project Office Country</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(projectOfficeCountryId) && projectOfficeCountryId.errors.required">
            Please select a project office country
          </span>
        </div>
      </div>

      <div class="col-6">
        <div
          class="form-group"
          [ngClass]="{ 'has-error': showValidationMessage(projectOfficeCityId) || null }"
          *ngIf="studyVM.countryCities.length > 0"
        >
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="projectOfficeCityId"
              name="projectOfficeCityId"
              [(ngModel)]="studyVM.study.projectOfficeCityId"
              required
              #projectOfficeCityId="ngModel"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.projectOfficeCityId" [value]="undefined" disabled selected></option>
              <option *ngFor="let countryCity of studyVM.countryCities" [ngValue]="countryCity.countryCityId">
                {{ countryCity.city }}
              </option>
            </select>
            <label for="offcCity">Project Office City</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(projectOfficeCityId) && projectOfficeCityId.errors.required">
            Please select a project office city
          </span>
        </div>

        <div class="form-group" *ngIf="!(studyVM.countryCities.length > 0)">
          <span class="ey-float-label">
            <select class="form-control form-select" appLabelFloat>
              <option *ngIf="!studyVM.study.projectOfficeCityId" [value]="undefined" disabled selected></option>
            </select>
            <label for="offcCity">Project Office City</label>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(startDate) || null }">
          <span class="ey-float-label">
            <p-calendar
              id="startDate"
              name="startDate"
              [(ngModel)]="studyVM.study.displayStartDate"
              dateFormat="dd-M-yy"
              #startDate="ngModel"
              [showIcon]="true"
              showButtonBar="true"
              required
              appLabelFloat
            ></p-calendar>
            <label for="startDt">Start Date</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(startDate) && startDate.errors.required"> Please enter a start date </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <span class="ey-float-label">
            <p-calendar
              id="endDate"
              name="endDate"
              [(ngModel)]="studyVM.study.displayEndDate"
              dateFormat="dd-M-yy"
              #endDate="ngModel"
              [showIcon]="true"
              utc="true"
              showButtonBar="true"
              appLabelFloat
            ></p-calendar>
            <label for="endDt">End Date</label>
          </span>

          <span class="help-block" *ngIf="checkStudyDate()"> End Date should be greater than Start Date. </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="fiscalYear"
              name="fiscalYear"
              [(ngModel)]="studyVM.study.fiscalYear"
              #fiscalYear="ngModel"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.fiscalYear" [value]="undefined" disabled selected></option>
              <option *ngFor="let fiscalYear of studyVM.fiscalYears" [ngValue]="fiscalYear.key">{{ fiscalYear.value }}</option>
            </select>
            <label for="fiscalyr">Fiscal Year</label>
          </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <p-checkbox
            id="isStudyConfidential"
            name="isStudyConfidential"
            [(ngModel)]="studyVM.study.isStudyConfidential"
            binary="true"
            #isStudyConfidential="ngModel"
          ></p-checkbox>
          <label class="form-check-label" for="isStudyConfidential">Set study to <strong>confidential</strong></label>
        </div>
        <div class="form-group">
          <div
            class="study-rd-btn ms-1"
            [ngClass]="{ 'has-error': (studyVM.study.isDemoStudy === undefined || studyVM.study.isDemoStudy === null) && submitted === true }"
          >
            <div class="usrDefined" style="display: inline-block; height: 28px">
              <label class="form-check-label">Mark as <strong>Demo/Test</strong> Study:</label>
              &nbsp;
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="markDemoStudyYes"
                  name="markDemoStudyYes"
                  [value]="true"
                  class="custom-control-input"
                  (change)="onDemoStudyTypeChanged()"
                  [(ngModel)]="studyVM.study.isDemoStudy"
                  required
                  #resultmarkstudy="ngModel"
                  [disabled]="leveragedStudy"
                />
                <label class="custom-control-label form-check-label" for="markDemoStudyYes">Yes</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  id="markDemoStudyNo"
                  name="markDemoStudyNo"
                  [value]="false"
                  class="custom-control-input"
                  (change)="onDemoStudyTypeChanged()"
                  [(ngModel)]="studyVM.study.isDemoStudy"
                  required
                  #resultmarkstudy="ngModel"
                  [disabled]="leveragedStudy"
                />
                <label class="custom-control-label form-check-label" for="markDemoStudyNo">No</label>
              </div>
            </div>
            <ng-container>
              <span class="help-block d-block mt-1" *ngIf="showValidationMessage(resultmarkstudy) && resultmarkstudy.errors.required">
                Please mark if it is Demo/Test study.
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div
          class="form-group"
          [ngClass]="{ 'has-error': showValidationMessage(engagementId) || null }"
          ngbTooltip="{{ 'study_engagementId' | tpbTooltip }}"
          tooltipClass="lengthyText"
        >
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="engagementId"
              name="engagementId"
              [(ngModel)]="studyVM.study.engagementId"
              #engagementId="ngModel"
              pattern="{{ regularExpressionPattern.AdvancedPattern }}"
              maxlength="30"
              minlength="8"
              required
              appLabelFloat
              (ngModelChange)="validateEngagementId()"
              (blur)="validateEngagementId()"
            />
            <label for="engagementId">Engagement Id</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(engagementId) && engagementId.errors.minlength">
            EngagementId must be at least 8 characters long.
          </span>
          <span class="help-block" *ngIf="showValidationMessage(engagementId) && engagementId.errors?.invalidNumber">
            Provided Engagement ID doesn't match to any of existing Engagement ID's - Please validate your Engagement ID
          </span>
          <span class="help-block" *ngIf="showValidationMessage(engagementId) && engagementId.errors.required"> Please enter a engagement Id </span>
          <span class="help-block" *ngIf="showValidationMessage(engagementId) && engagementId.errors?.pattern">
            special characters are not allowed. (for example: !@#$%^&* etc)
          </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <span class="ey-float-label">
            <input
              type="text"
              class="form-control"
              id="engagementClientChannelName"
              name="engagementClientChannelName"
              [(ngModel)]="studyVM.study.engagementClientChannelName"
              #engagementClientChannelName="ngModel"
              appLabelFloat
              disabled="true"
            />
            <label for="engagementClientChannelName">Client Channel Name</label>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group" [ngClass]="{ 'has-error': studyVM.selectedBenchmarkCountries.length === 0 && submitted === true }">
          <div class="p-checkbox-grp usrDefined" ngbTooltip="{{ 'studyInfo_worldRegions' | tpbTooltip }}" tooltipClass="lengthyText">
            <label for="region-country">World regions (geographical)</label>
            <app-world-regions
              [regionCountries]="studyVM.regionCountries_multi"
              [selectedBenchmarkCountries]="studyVM.selectedBenchmarkCountries"
            ></app-world-regions>
          </div>
          <span class="help-block" *ngIf="studyVM.selectedBenchmarkCountries.length === 0 && submitted === true">
            Please select a region and country
          </span>
        </div>
      </div>
    </div>
  </div>

  <h5>Period of Study</h5>
  <div id="dvStudyPeriod">
    <div class="row">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(periodOfStudyFrom) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="periodOfStudyFrom"
              name="periodOfStudyFrom"
              [(ngModel)]="studyVM.study.periodOfStudyFrom"
              required
              #periodOfStudyFrom="ngModel"
              [disabled]="leveragedStudy"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.periodOfStudyFrom" [value]="undefined" disabled selected></option>
              <option *ngFor="let yr of studyVM.years" [ngValue]="yr">{{ yr }}</option>
            </select>
            <label>Period Beginning</label>
          </span>
          <span class="help-block">
            <span *ngIf="showValidationMessage(periodOfStudyFrom) && periodOfStudyFrom.errors.required"> Please select a period of beginning </span>
          </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(periodOfStudyTo) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="periodOfStudyTo"
              name="periodOfStudyTo"
              [(ngModel)]="studyVM.study.periodOfStudyTo"
              required
              #periodOfStudyTo="ngModel"
              [disabled]="leveragedStudy"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.periodOfStudyTo" [value]="undefined" disabled selected></option>
              <option *ngFor="let yr of studyVM.years" [ngValue]="yr">{{ yr }}</option>
            </select>
            <label>Period Ending</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(periodOfStudyTo) && periodOfStudyTo.errors.required">
            Please select a period of ending
          </span>
          <span class="help-block" *ngIf="checkPeriodEnding()"> Period ending should be greater than period of beginning. </span>
          <span class="help-block" *ngIf="checkPeriodTimeFrame()"> The maximum allowed period of study should not exceed 10 years. </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="study-rd-btn ms-1">
          <ng-template #alignment31TooltipContent
            ><div class="tooltip-31-alignment">{{ 'studyInfo_31Alignment' | tpbTooltip }}</div></ng-template
          >
          <ng-template #alignment5_7TooltipContent
            ><div class="tooltip-5-7-alignment">{{ 'studyInfo_5_7Alignment' | tpbTooltip }}</div></ng-template
          >

          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="mar31alignment"
              name="mar31alignment"
              [value]="fyAlignmentMethod.March31"
              class="custom-control-input"
              [(ngModel)]="studyVM.study.fyAlignmentMethodID"
              required
              [disabled]="leveragedStudy"
            />
            <label
              class="custom-control-label form-check-label"
              for="mar31alignment"
              [ngbTooltip]="alignment31TooltipContent"
              tooltipClass="lengthyText"
              >Mar 31<sup>st</sup> FY Alignment</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="5_7alignment"
              name="5_7alignment"
              [value]="fyAlignmentMethod.Previous7Month"
              class="custom-control-input"
              [(ngModel)]="studyVM.study.fyAlignmentMethodID"
              [disabled]="leveragedStudy"
            />
            <label
              class="custom-control-label form-check-label"
              for="5_7alignment"
              [ngbTooltip]="alignment5_7TooltipContent"
              tooltipClass="lengthyText"
              >5/7 FY Alignment</label
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="studyVM.study.fyAlignmentMethodID === fyAlignmentMethod.Previous7Month">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(fyAlignmentEnd) || null }">
          <span class="ey-float-label">
            <p-calendar
              id="fyAlignmentEnd"
              name="fyAlignmentEnd"
              [(ngModel)]="studyVM.study.displaytestedPartyFiscalYearEnd"
              dateFormat="dd-M-yy"
              #fyAlignmentEnd="ngModel"
              [showIcon]="true"
              showButtonBar="true"
              [disabled]="leveragedStudy"
              required
              appLabelFloat
            ></p-calendar>
            <label for="fyAlignmentEnd">Tested Party Fiscal Year End</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(fyAlignmentEnd) && fyAlignmentEnd.errors.required"> Please enter an end date </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(monthsBack) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="monthsBack"
              name="monthsBack"
              [(ngModel)]="studyVM.study.monthsBack"
              required
              #monthsBack="ngModel"
              [disabled]="leveragedStudy"
              (change)="handleCurrencyChange()"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.monthsBack" [value]="undefined" disabled selected></option>
              <option *ngFor="let month of studyVM.monthsBack" [ngValue]="month">
                {{ month }}
              </option>
            </select>
            <label>Months Back</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(monthsBack) && monthsBack.errors.required"> Please select a number of months </span>
        </div>
      </div>
    </div>
  </div>

  <h5>Currency Information</h5>
  <div id="dvCurrency">
    <div class="row">
      <div class="col-12">
        <label>Reference Currency</label>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(currencyId) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="currencyId"
              name="currencyId"
              [(ngModel)]="studyVM.study.currencyId"
              required
              #currencyId="ngModel"
              [disabled]="leveragedStudy"
              (change)="handleCurrencyChange()"
              appLabelFloat
            >
              <option *ngIf="!studyVM.study.currencyId" [value]="undefined" disabled selected></option>
              <option *ngFor="let currency of studyVM.currencies" [ngValue]="currency.currencyId">
                {{ currency.currencyName }} - {{ currency.currencyCode }}
              </option>
            </select>
            <label>Study Reference Currency</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(currencyId) && currencyId.errors.required">
            Please select a study reference currency
          </span>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group" [ngClass]="{ 'has-error': showValidationMessage(currencyUnitId) || null }">
          <span class="ey-float-label">
            <select
              class="form-control form-select"
              id="currencyUnitId"
              name="currencyUnitid"
              [(ngModel)]="studyVM.study.currencyUnitId"
              (change)="handleCurrencyChange()"
              required
              #currencyUnitId="ngModel"
              [disabled]="leveragedStudy"
              appLabelFloat
            >
              <option *ngFor="let cunit of studyVM.currencyUnits" [ngValue]="cunit.lookupId">{{ cunit.displayText }}</option>
            </select>
            <label>Study Currency Units</label>
          </span>
          <span class="help-block" *ngIf="showValidationMessage(currencyUnitId) && currencyUnitId.errors.required">
            Please select a study currency units
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <p-checkbox
            id="functionalCurrency"
            name="functionalCurrency"
            [(ngModel)]="studyVM.study.useFunctionalCurrency"
            binary="true"
            #functionalCurrency="ngModel"
          ></p-checkbox>
          <label class="form-check-label" for="functionalCurrency">Use Functional Currency for Reports</label>
          <p class="functionalCurrText">Check the Functional currency box to generate Reports in Functional Currency</p>
        </div>
      </div>
    </div>
  </div>

  <h5>PLI Settings</h5>
  <div id="dvFinancialResultsFormatting">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div
            [ngClass]="{
              'has-error':
                (studyVM.selectedRatios === undefined || (studyVM.selectedRatios !== undefined && studyVM.selectedRatios.length === 0)) &&
                submitted === true,
            }"
          >
            Selected PLIs
            <div>
              <ng-container *ngFor="let ratio of studyVM.ratios; index as i; let isLast = last">
                <ng-template #ratioTooltipContent
                  ><div class="tooltip-ratio">{{ 'ratio_' + ratio.acronym | tpbTooltip }}</div></ng-template
                >

                <div class="usrDefined">
                  <div class="custom-control custom-control-inline">
                    <p-checkbox
                      id="ratio_{{ i + 1 }}"
                      name="ratio_{{ i + 1 }}"
                      [value]="ratio.ratioId"
                      [(ngModel)]="studyVM.selectedRatios"
                      required
                      #resultformat="ngModel"
                      (onChange)="validatePLIBaseCalculationSettings()"
                      [disabled]="leveragedStudy"
                    ></p-checkbox>
                    <label class="form-check-label" for="ratio_{{ i + 1 }}" [ngbTooltip]="ratioTooltipContent">{{ ratio.name }}</label>
                  </div>
                </div>
                <ng-container *ngIf="isLast">
                  <span class="help-block d-block mt-1" *ngIf="showValidationMessage(resultformat) && resultformat.errors.required">
                    Please select a PLI.
                  </span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h5>Default Base for PLI Calculation</h5>
    <div *ngIf="true" class="row">
      <div class="col-12">
        <div class="form-group">
          <div [ngClass]="">
            <div [title]="disableDefaultBasePLISetting ? 'Selected PLI does not include Operating Revenue' : ''">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  class="custom-control-input"
                  id="PLICalcBaseOpr"
                  name="PLICalcBaseOpr"
                  [value]="basePLIVendorAccount.OperatingRevenue"
                  [(ngModel)]="studyVM.study.defaultBasePLIVendorAccountId"
                  [disabled]="disableDefaultBasePLISetting"
                />
                <label class="custom-control-label form-check-label" for="PLICalcBaseOpr">Operating Revenue</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  class="custom-control-input"
                  id="PLICalcBaseNetSales"
                  name="PLICalcBaseNetSales"
                  [value]="basePLIVendorAccount.NetSales"
                  [(ngModel)]="studyVM.study.defaultBasePLIVendorAccountId"
                  [disabled]="disableDefaultBasePLISetting"
                />
                <label class="custom-control-label form-check-label" for="PLICalcBaseNetSales">Net Sales</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          Default Average Method
          <div
            class="study-rd-btn ms-1"
            style="width: 100%; display: flex"
            [ngClass]="{ 'has-error': studyVM.study.averagingMethodID === undefined && submitted === true }"
          >
            <div>
              <ng-container *ngFor="let averagingMethod of studyVM.defaultAveragingMethods; index as i; let isLast = last">
                <ng-template #averageMethodTooltipContent
                  ><div class="tooltip-avarage-method">{{ 'studyInfo_averageMethod_' + (i + 1) | tpbTooltip }}</div></ng-template
                >

                <div class="usrDefined" style="display: inline-block">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="averagingMethod_{{ i + 1 }}"
                      name="averagingMethod_{{ i + 1 }}"
                      [value]="averagingMethod.lookupId"
                      class="custom-control-input"
                      [(ngModel)]="studyVM.study.averagingMethodID"
                      required
                      #resultformataverage="ngModel"
                      [disabled]="leveragedStudy"
                    />
                    <label
                      class="custom-control-label form-check-label"
                      for="averagingMethod_{{ i + 1 }}"
                      [ngbTooltip]="averageMethodTooltipContent"
                      tooltipClass="lengthyText"
                      placement="{{ i === 0 ? 'top-left' : 'top' }}"
                      >{{ averagingMethod.displayText }}</label
                    >
                  </div>
                </div>
                <ng-container *ngIf="isLast">
                  <span class="help-block d-block mt-1" *ngIf="showValidationMessage(resultformataverage) && resultformataverage.errors.required">
                    Please select a Default Average Method.
                  </span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          Default Interquartile Calculation Method
          <div class="study-rd-btn ms-1" [ngClass]="{ 'has-error': studyVM.study.financialResultFormatId === undefined && submitted === true }">
            <ng-container *ngFor="let rFormat of studyVM.financialResultsFormatting; index as i; let isLast = last">
              <ng-template #interquartileMethodTooltipContent
                ><div class="tooltip-interquartile-method">{{ 'studyInfo_interquartileMethod_' + (i + 1) | tpbTooltip }}</div></ng-template
              >

              <div class="usrDefined">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="rFormat_{{ i + 1 }}"
                    name="resultformat_{{ i + 1 }}"
                    [value]="rFormat.lookupId"
                    class="custom-control-input"
                    [(ngModel)]="studyVM.study.financialResultFormatId"
                    required
                    #resultformat="ngModel"
                    [disabled]="leveragedStudy"
                  />
                  <label
                    class="custom-control-label form-check-label"
                    for="rFormat_{{ i + 1 }}"
                    [ngbTooltip]="interquartileMethodTooltipContent"
                    tooltipClass="lengthyText"
                    >{{ rFormat.displayText }}</label
                  >
                </div>
              </div>
              <ng-container *ngIf="isLast">
                <span class="help-block d-block mt-1" *ngIf="showValidationMessage(resultformat) && resultformat.errors.required">
                  Please select a financial results format.
                </span>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div [ngbTooltip]="studyInfoStudySettingsTooltip" placement="top-left" tooltipClass="lengthyText line-break">
    <h5>Study Settings</h5>
    <div id="dvStudySettings">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="study-rd-btn ms-1" [ngClass]="{ 'has-error': studyVM.study.studySettingId === undefined && submitted === true }">
              <ng-container *ngFor="let setting of studyVM.studySettings; index as i; let isLast = last">
                <div class="usrDefined">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="setting_{{ i + 1 }}"
                      name="studySetting_{{ i + 1 }}"
                      [value]="setting.lookupId"
                      class="custom-control-input"
                      [(ngModel)]="studyVM.study.studySettingId"
                      required
                      #studySetting="ngModel"
                      [disabled]="leveragedStudy"
                    />
                    <label class="custom-control-label form-check-label" for="setting_{{ i + 1 }}">{{ setting.displayText }}</label>
                  </div>
                </div>
                <ng-container *ngIf="isLast">
                  <span class="help-block d-block mt-1" *ngIf="showValidationMessage(studySetting) && studySetting.errors.required">
                    Please select a study settings.
                  </span>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #studyInfoStudySettingsTooltip>
    <div class="text-center">
      <div class="mb-1">Only the selected fields of business information will be screened in the automated Keyword Screening step.</div>
      <div>
        The selected fields of business information will be displayed on the Business Description Review tab by default but you can add additional
        columns by clicking the three dots icon in the header to the far left of the grid.
      </div>
      <div *ngIf="studyVM.study.isAISuggestionsEnabled" class="AI-engine-warning">
        AI engine will use all available data to generate it's predictions.
      </div>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <p-checkbox id="translateNLChk" name="translateNLChk" [(ngModel)]="studyVM.study.translateNativeLanguageTD" binary="true"></p-checkbox>
        <label class="form-check-label" for="functionalCurrency">Translate Native Language Trade Description</label>
        <p class="functionalCurrText">Check Native Language TD box to get it translated for all companies that pass Search Strategy</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div class="row"><span for="isAISuggestionsEnabled">Enable AI assisted suggestions on the BDR Grid</span></div>
        <div class="row switch-container-study-setup">
          <div class="custom-control custom-control-inline">
            <label class="ai-enabled custom-control-label form-check-label" placement="top">No</label>
            <p-inputSwitch name="isAISuggestionsEnabled" [(ngModel)]="studyVM.study.isAISuggestionsEnabled" [disabled]="false"></p-inputSwitch>
            <label class="ai-disabled custom-control-label form-check-label">Yes</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <h5>Display Settings</h5>
    <div id="dvStudySettings">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="study-rd-btn ms-1">
              <label class="me-3">Number of companies displayed per page:</label>
              &nbsp;
              <ng-container *ngFor="let option of studyVM.itemsPerPageOptions; index as i">
                <div class="usrDefined">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="displaySetting_{{ i + 1 }}"
                      name="displaySetting_{{ i + 1 }}"
                      [value]="option"
                      class="custom-control-input"
                      [(ngModel)]="studyVM.study.itemsPerPage"
                      required
                      #studySetting="ngModel"
                      [disabled]="leveragedStudy"
                    />
                    <label class="custom-control-label form-check-label" for="displaySetting_{{ i + 1 }}">{{ option }}</label>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</fieldset>
